module.exports = __webpack_public_path__ + "static/media/velocidad.60c17b65.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/velocidad.svg
// module id = 123
// module chunks = 0